import React from "react";
import "./View_img_Modal.css";
import { Modal } from "react-bootstrap";
import { IDS } from "../../../../utils/IDS";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";

function View_img_Modal({ image, setImage, onHide, ...props }) {
  const imgUrl = image ? `${IDS.IMG_URL}${image}` : null;

  console.log(imgUrl, "imgUrl");

  const handleClose = () => {
    if (setImage) {
      setImage("");
    }

    if (onHide) {
      onHide();
    }
  };

  console.log(image, "image");

  return (
    <Modal
      {...props}
      size="lg"
      centered
      className="View_img_Modal"
      onHide={handleClose}
    >
      <Modal.Header closeButton>
        <Modal.Title>View Document</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="img_holder d-flex justify-content-center align-items-center">
          {image == null ? (
            <div
              style={{
                width: "200px",
                height: "200px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#f1f1f1",
                borderRadius: "10px",
              }}
            >
              <FontAwesomeIcon icon={faUser} size="5x" />
            </div>
          ) : (
            <img
              src={imgUrl}
              alt="document"
              className="view_documents_img"
              onError={(e) => {
                e.target.style.display = "none";
              }}
            />
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default View_img_Modal;
